import { render, staticRenderFns } from "./AdminResetPassword.vue?vue&type=template&id=ebafaea8&"
import script from "./AdminResetPassword.vue?vue&type=script&lang=ts&"
export * from "./AdminResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports